export default function columns(t) {
  return [
    {
      title: t('general.frequency'),
      field: 'descriptionAlertDay',
      render: (rowData) => t(`setting-expiration-alerts.${rowData.alertDay}`),
    },
  ];
}
